module.exports = __webpack_public_path__ + "media/images/default/pages/depth_views/pagination/next-1e01967d7081afa36ca7ad8e2fffd60e.svg";